<template>
  <aside class="app-sidebar">
    <!-- Logo 区 -->
    <div class="logo-area">
      <div class="logo-mark">
        <img :src="logo" alt="智猎招聘" />
      </div>
      <div class="logo-text">
        <div class="logo-title">智猎AI助手</div>
        <div class="logo-sub">ZLAI ASSISTANT</div>
      </div>
    </div>

    <!-- 导航菜单 -->
    <el-scrollbar class="menu-scroll" :noresize="false" wrap-class="menu-scroll-wrap">
      <el-menu :default-active="activeMenuIndex" router>
        <el-menu-item v-for="ch in channels" :key="ch.key + '-item'" :index="menuPath(ch)">
          <i :class="[ch.icon, { 'platform-running': isTaskRunning(ch.key) }]" />
          <span class="menu-label">{{ ch.label }}</span>
          <span v-if="isRecruitmentChannel(ch)" class="channel-meta"
            :class="{ 'is-running': isTaskRunning(ch.key) }"
            :title="taskStatuses[ch.key] ? `启动中：${taskStatuses[ch.key].type}` : '未启动'">
            <span class="channel-state"><i class="state-dot" />{{ isTaskRunning(ch.key) ? '启动中' : '未启动' }}</span>
            <button v-if="isTaskRunning(ch.key)" type="button" class="channel-stop"
              :aria-label="`结束${ch.label}AI任务`" :title="`结束${ch.label}AI任务`"
              @click.stop.prevent="stopChannelTask(ch.key)">
              <i class="el-icon-switch-button" aria-hidden="true" />
            </button>
            <i v-else class="el-icon-video-play channel-play" aria-hidden="true" />
          </span>
        </el-menu-item>
      </el-menu>
    </el-scrollbar>

    <!-- 底部用户卡片 -->
    <div class="user-area">
      <el-dropdown trigger="click" placement="top-end" @command="handleCommand">
        <div class="user-card">
          <div class="account-status" aria-hidden="true">
            <i class="el-icon-check" />
          </div>
          <div class="user-meta">
            <div class="user-greeting">{{ greeting }}，{{ usernick }}</div>
            <div class="user-expiry">到期时间：{{ usertime }}</div>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">
            <i class="el-icon-switch-button" /> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </aside>
</template>

<script>
import { channels } from '@/config/channels'
import { getTaskStatuses, stopTask, RECRUITMENT_TASK_STATUS_EVENT } from '@/utils/bossTask'
import logo from '@/assets/logo.png'

export default {
  data() {
    return { channels, logo, taskStatuses: getTaskStatuses(), usernick: '', usertime: '' }
  },
  mounted() {
    this.syncLoginInfo()
    window.addEventListener(RECRUITMENT_TASK_STATUS_EVENT, this.syncTaskStatuses)
    window.addEventListener('login-info-change', this.syncLoginInfo)
    window.addEventListener('storage', this.syncTaskStatuses)
    window.addEventListener('storage', this.syncLoginInfo)
  },
  beforeDestroy() {
    window.removeEventListener(RECRUITMENT_TASK_STATUS_EVENT, this.syncTaskStatuses)
    window.removeEventListener('login-info-change', this.syncLoginInfo)
    window.removeEventListener('storage', this.syncTaskStatuses)
    window.removeEventListener('storage', this.syncLoginInfo)
  },
  computed: {
    activePath() {
      return this.$route.path
    },
    activeMenuIndex() {
      const channel = this.$route.params.channel
      if (channel) {
        const item = this.channels.find(ch => ch.key === channel)
        return item ? this.menuPath(item) : this.activePath
      }
      return this.activePath
    },
    greeting() {
      const hour = new Date().getHours()
      if (hour < 6) return '凌晨好'
      if (hour < 12) return '早上好'
      if (hour < 18) return '下午好'
      return '晚上好'
    }
  },
  methods: {
    syncLoginInfo() {
      try {
        const loginInfo = JSON.parse(sessionStorage.getItem('LoginInfo') || '{}')
        this.usernick = loginInfo.usernick || ''
        this.usertime = this.formatUsertime(loginInfo.usertime)
      } catch (error) {
        this.usernick = ''
        this.usertime = ''
      }
    },
    formatUsertime(value) {
      if (value === undefined || value === null || value === '') return ''
      const text = String(value).trim()
      const dateMatch = text.match(/^(\d{4}[-/.年]\d{1,2}[-/.月]\d{1,2}日?)/)
      if (dateMatch) return dateMatch[1].replace(/[/.年]/g, '-').replace('月', '-').replace('日', '')

      const timestamp = Number(value)
      if (!Number.isNaN(timestamp) && timestamp > 0) {
        const date = new Date(timestamp < 1e12 ? timestamp * 1000 : timestamp)
        if (!Number.isNaN(date.getTime())) {
          const pad = part => String(part).padStart(2, '0')
          return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
        }
      }
      return text
    },
    isRecruitmentChannel(channel) {
      return ['boss', 'liepin', 'zhilian'].includes(channel.key)
    },
    syncTaskStatuses() {
      this.taskStatuses = getTaskStatuses()
    },
    isTaskRunning(channel) {
      return Boolean(this.taskStatuses[channel])
    },
    stopChannelTask(channel) {
      const status = stopTask(channel)
      if (!status) return
      this.syncTaskStatuses()
      const channelLabel = this.channels.find(item => item.key === channel)?.label || channel
      this.$message.success(`已发送结束${channelLabel}${status.type}任务指令`)
    },
    menuPath(channel) {
      if (channel.key === 'log') return '/log'
      if (channel.key === 'ats') return '/ats'
      // 当前渠道设置的默认入口为招呼设置，点击父级直接进入该页面。
      return '/' + channel.key + '/greet'
    },
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确定退出登录吗？', '提示', { type: 'warning' })
          .then(() => {
            sessionStorage.removeItem('Token')
            sessionStorage.removeItem('LoginInfo')
            localStorage.removeItem('Login')
            if (this.$route.path !== '/login') this.$router.replace('/login')
          })
          .catch(() => { })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-sidebar {
  width: $sidebar-width;
  flex: 0 0 $sidebar-width;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--bg-sidebar);
  border-right: 1px solid var(--border-hairline);
  overflow: hidden;
  transition: flex-basis 0.25s ease, background-color 0.25s ease;
}

// ---------- Logo ----------
.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
  height: $header-height;
  padding: 0 14px;
  border-bottom: 1px solid var(--divider);
  overflow: hidden;
  flex-shrink: 0;

  .logo-mark {
    width: 34px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .logo-text {
    white-space: nowrap;
    user-select: none;

    .logo-title {
      font-size: 16px;
      font-weight: 700;
      color: var(--text-primary);
      line-height: 1.2;
    }

    .logo-sub {
      font-size: 10px;
      letter-spacing: 1px;
      color: var(--text-secondary);
    }
  }
}

// ---------- 菜单 ----------
.menu-scroll {
  flex: 1;
  min-height: 0;

  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
  }

  :deep(.el-menu) {
    border-right: none;
    background: transparent;
    padding: 8px;
  }

  :deep(.el-menu-item) {
    display: flex;
    align-items: center;
    height: 42px;
    line-height: 42px;
    border-radius: $radius-md;
    margin: 3px 0;
    padding: 0 12px !important;
    color: var(--text-regular);
    font-size: 14px;
    white-space: nowrap;
    transition: color .18s ease, background-color .18s ease, transform .18s ease;

    i {
      width: 18px;
      color: var(--text-secondary);
      margin-right: 10px;
      font-size: 16px;
      text-align: center;
      transition: color .18s ease;
    }

    &:hover {
      background: var(--bg-hover);
      color: var(--text-primary);
    }
  }

  :deep(.el-menu-item .menu-label) {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :deep(.el-menu-item .channel-meta) {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 8px;
    margin-left: auto;
    padding-left: 12px;
  }

  :deep(.el-menu-item .channel-state) {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 24px;
    padding: 0 8px;
    border: 1px solid transparent;
    border-radius: 999px;
    background: #f1f3f7;
    color: #8190a5;
    font-size: 10px;
    font-weight: 400;
    line-height: 1;
  }

  :deep(.el-menu-item .channel-meta.is-running .channel-state) {
    border-color: rgba(43, 176, 119, .24);
    background: rgba(43, 176, 119, .09);
    color: #35b77c;
  }

  :deep(.el-menu-item .channel-meta.is-running .state-dot) {
    background: #35b77c;
    box-shadow: 0 0 0 3px rgba(53, 183, 124, .14);
  }

  :deep(.el-menu-item .platform-running),
  :deep(.el-menu-item.is-active .platform-running) {
    color: #35b77c !important;
  }

  :deep(.el-menu-item .state-dot) {
    width: 6px;
    height: 6px;
    margin: 0;
    border-radius: 50%;
    background: #b9c2cf;
  }

  :deep(.el-menu-item .channel-play) {
    display: grid;
    place-items: center;
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    margin: 0;
    border: 1px solid rgba(82, 112, 255, .2);
    border-radius: 50%;
    background: rgba(255, 255, 255, .82);
    color: #617bff;
    font-size: 16px;
    transition: color .18s ease, border-color .18s ease, background-color .18s ease, transform .18s ease;
  }

  :deep(.el-menu-item .channel-stop) {
    display: grid;
    place-items: center;
    width: 26px;
    height: 26px;
    flex: 0 0 26px;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(228, 86, 86, .3);
    border-radius: 50%;
    background: rgba(228, 86, 86, .08);
    color: #e45656;
    cursor: pointer;
    transition: transform .18s ease, background-color .18s ease, border-color .18s ease;
  }

  :deep(.el-menu-item .channel-stop:hover) {
    transform: scale(1.08);
    border-color: rgba(228, 86, 86, .55);
    background: rgba(228, 86, 86, .18);
  }

  :deep(.el-menu-item .channel-stop i) {
    width: auto;
    margin: 0;
    color: inherit;
    font-size: 15px;
  }

  :deep(.el-menu-item:hover .channel-play) {
    border-color: var(--brand-glow);
    background: var(--brand-weak);
    color: var(--brand);
    transform: scale(1.05);
  }

  :deep(.el-menu-item.is-active .channel-state) {
    color: var(--text-secondary);
  }

  :deep(.el-menu-item.is-active .channel-play) {
    border-color: var(--brand-glow);
    background: var(--bg-card);
    color: var(--brand);
  }

  // 激活项：品牌色浅底与左侧标记，强化当前所在渠道
  :deep(.el-menu-item.is-active) {
    background: var(--bg-active);
    color: var(--brand);
    font-weight: 600;
    box-shadow: inset 3px 0 0 var(--brand);

    i {
      color: var(--brand);
    }
  }
}

// ---------- 用户区 ----------
.user-area {
  flex-shrink: 0;
  padding: 10px;

  // el-dropdown 默认 inline-block 会把卡片收缩成内容宽度，改为块级占满
  :deep(> .el-dropdown) {
    display: block;
    width: 100%;
  }

  .user-card {
    display: flex;
    align-items: center;
    gap: 9px;
    width: 100%;
    box-sizing: border-box;
    min-height: 48px;
    padding: 7px 9px;
    border: 1px solid var(--border-hairline);
    border-radius: 9px;
    background: var(--bg-header);
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover,
    &:focus {
      background: var(--bg-active);
      border-color: var(--brand-glow);
      outline: none;
    }

    .account-status {
      position: relative;
      display: grid;
      place-items: center;
      width: 22px;
      height: 22px;
      flex-shrink: 0;
      border-radius: 50%;
      background: rgba(45, 194, 126, .12);
      color: #42c98b;
      font-size: 11px;
    }

    .user-meta {
      display: flex;
      flex-direction: column;
      gap: 3px;
      min-width: 0;
      white-space: nowrap;

      .user-greeting {
        color: var(--text-primary);
        font-size: 12px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .user-expiry {
        color: var(--text-secondary);
        font-size: 10px;
        line-height: 1.2;
      }
    }
  }
}

@media (max-width: 820px) {
  .app-sidebar {
    width: 184px;
    flex-basis: 184px;
  }

  .logo-area {
    padding: 0 12px;
    gap: 8px;
  }

  .menu-scroll :deep(.el-menu) {
    padding: 7px;
  }
}

@media (max-width: 520px) {
  .app-sidebar {
    width: 156px;
    flex-basis: 156px;
  }

  .logo-area {
    padding: 0 9px;
    gap: 7px;
  }

  .logo-area .logo-mark {
    width: 28px;
  }

  .logo-area .logo-title {
    font-size: 14px;
  }

  .logo-area .logo-sub {
    font-size: 8px;
    letter-spacing: .5px;
  }

  .menu-scroll :deep(.el-menu) {
    padding: 6px;
  }

  .menu-scroll :deep(.el-menu-item) {
    padding-left: 10px !important;
    font-size: 13px;
  }

  .user-area {
    padding: 7px;
  }

  .user-card {
    gap: 6px;
    padding: 6px;
  }

  .user-card .account-status {
    width: 19px;
    height: 19px;
  }

  .user-card .user-expiry {
    font-size: 9px;
  }
}
</style>
